
import { antiNameHandler } from '../../modules/anti_name_handler';
import CustomLinearProgress from '../../modules/custom_linear_progress';
import getStringsBasedLang from '../../strings/get_strings'


export default function AvCard(props) {
    return (
        <div className='w-full border-2 border-gray-200 p-2 rounded-lg bg-white'>
            {/* top */}
            <div className='flex justify-end items-center'>
                <div className='flex justify-center items-center'>
                    <span className='primary_text_color text-sm englishIranSans'>{antiNameHandler(props.av_name)}</span>
                    <img className='w-6 h-6 mr-1' src={require(`../../assets/icons/${antiNameHandler(props.av_name) === 'Unknown' ? 'question' : props.av_name}.png`)} alt="Icon" />
                </div>
            </div>
            {/* bottom */}
            <div className='flex flex-col'>
                <span
                    className='secondry_text_color text-xs text-left px-1 truncate mt-1'
                >
                    {/*     <div className='text-left'> */}
                    {(Object.keys(props.av_data.current_file).length !== 0 && props.av_data.current_file[`${props.av_name}`]) ?
                        <span dir='ltr' title={props.av_data.current_file[`${props.av_name}`]}>{props.av_data.current_file[`${props.av_name}`]}</span>
                        :
                        getStringsBasedLang("general_scanning")}
                    {/*   </div> */}
                </span>
                <div className='mt-2' dir='rtl'><CustomLinearProgress value={props.av_data.progress[`${props.av_name}`] !== undefined ? props.av_data.progress[`${props.av_name}`] : 0} /></div>
            </div>
        </div>
    )
}
